import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface GenericListItem {
    id: number;
    name: string;
}

const ReportFencingPickedUpData = (props: RouteComponentProps<{}>) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [customerOptions, setCustomerOptions] = React.useState<GenericListItem[]>([]);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [customerId, setCustomerId] = React.useState(-1);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunFencePickupsReport&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                axios.get('api/Customer/GetCustomersForDropdown?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    setCustomerOptions(res.data);
                    setLoading(false);
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleStartDateChange = (e: any) => {
        let error = errors;
        delete error["startDate"];
        setErrors(error);

        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e: any) => {
        let error = errors;
        delete error["endDate"];
        setErrors(error);

        setEndDate(e.target.value);
    }

    const validate = () => {
        let errorsList: any = {};
        let formIsValid = true;

        if (!startDate) {
            formIsValid = false;
            errorsList["startDate"] = "Start Date is required";
        }

        if (!endDate) {
            formIsValid = false;
            errorsList["endDate"] = "End Date is required";
        }

        if (startDate && endDate && endDate < startDate) {
            formIsValid = false;
            errorsList["startDate"] = "Start Date must be < End Date";
        }

        setErrors(errorsList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            runRpt();
        }
    }

    const runRpt = async () => {
        var url = "/report/ReportFencingPickedUpJobs/" + startDate + "/" + endDate + "/" + customerId + "/-1/-1";
        window.open(url, '_blank');
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios('api/Report/ExportFencingPickedUpJobsReportData?StartDate=' + startDate + "&EndDate=" + endDate + "&CustomerId=" + customerId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "FencingPickedUpJobs.xlsx");
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Fencing Jobs Picked Up</h1>
            </div>
            <div className="marginTop20">
                <span>Select a Start Date and End Date to return all fencing and braces picked up within the dates selected. </span>
            </div>
            <label className="input-group" htmlFor="startDate">
                <span className="label">Start Date</span>
                <input type='date' id="startDate" name="startDate" className='input' value={startDate} onChange={(e) => handleStartDateChange(e)}></input>
            </label>
            <span className={errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["startDate"]}</span>
            <label className="input-group" htmlFor="endDate">
                <span className="label">End Date</span>
                <input type='date' id="endDate" name="endDate" className='input' value={endDate} onChange={(e) => handleEndDateChange(e)}></input>
            </label>
            <span className={errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["endDate"]}</span>
            <label className="input-group" htmlFor="customerId">
                <span className="label">Customer</span>
                <select className="select" id="customerId" name="customerId" value={customerId} onChange={(e) => setCustomerId(Number(e.target.value))}>
                    <option defaultValue="-1" value="-1"></option>
                    {customerOptions.map(cust =>
                        <option key={cust.id} value={cust.id}>{cust.name}</option>
                    )};
                </select>
            </label>
            <button className="defaultbutton marginLeftLabel marginRight10" type='button' onClick={runReport}>Run Report</button>
            <button className="defaultbutton" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)
};

export default ReportFencingPickedUpData;